export const departments = [ 'Department of Medical Science', 'Department of Computer Engineering', 'Department of Pharmacy', 'Department of Management'];
export const designations = [ 'Associate Professor', 'Assistant Professor', 'Professor', 'Dean'];

export const academicYears = Array.from({ length: 75 }, (_, i) => {
    const year = new Date().getFullYear() - i;
    return { value: year.toString(), label: `${year}-${(year + 1) % 100}` };
  });